import React, { useEffect, useMemo, useState } from "react";
import { GraduationCap, Loader2 } from "lucide-react";
import api from "../lib/api";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function OdlCourses() {
  const [courses, setCourses] = useState(null);
  const [cat, setCat] = useState("All");

  useEffect(() => { api.get("/public/odl-courses").then((r) => setCourses(r.data)).catch(() => setCourses([])); }, []);

  const cats = useMemo(() => ["All", ...Array.from(new Set((courses || []).map((c) => c.category)))], [courses]);
  const shown = (courses || []).filter((c) => cat === "All" || c.category === cat);

  return (
    <div className="min-h-[70vh] bg-white">
      <div className="bg-[#004030] text-white py-14 px-5">
        <div className="max-w-6xl mx-auto">
          <p className="text-[#e0c05a] font-semibold tracking-wide uppercase text-sm">Online & Distance Learning</p>
          <h1 className="font-display text-3xl md:text-5xl font-bold mt-2">ODL & Certificate Courses</h1>
          <p className="text-white/80 mt-3 max-w-2xl">Study remotely with UCSI University's Open & Distance Learning programmes — micro-credentials, professional certifications, ESG short courses and more, delivered through GDIH Elite Education.</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-5 py-10">
        {!courses ? <div className="text-center py-16 text-slate-400"><Loader2 className="animate-spin inline" /> Loading…</div> : (
          <>
            <div className="flex flex-wrap gap-2 mb-8">
              {cats.map((c) => (
                <button key={c} onClick={() => setCat(c)} data-testid={`odl-cat-${c}`}
                  className={`text-sm font-medium px-4 py-2 rounded-full border transition-colors ${cat === c ? "bg-[#004030] text-white border-[#004030]" : "border-slate-200 text-slate-600 hover:border-[#004030]"}`}>{c}</button>
              ))}
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="odl-grid">
              {shown.map((c) => (
                <div key={c.id} className="rounded-2xl border border-slate-100 p-5 hover:shadow-lg hover:border-[#c9a227] transition-all flex flex-col">
                  <div className="w-11 h-11 rounded-xl bg-[#f0f6f3] text-[#004030] grid place-items-center"><GraduationCap size={20} /></div>
                  <span className="text-[10px] font-bold uppercase tracking-wide text-[#c9a227] mt-3">{c.category}</span>
                  <h3 className="font-display font-bold text-[#012a1e] mt-1 leading-snug">{c.name}</h3>
                  <p className="text-sm text-slate-500 mt-1.5 flex-1">{c.desc}</p>
                  <div className="flex items-center justify-between mt-4">
                    <span className="font-bold text-[#004030]">{c.price}</span>
                    <Link to="/contact"><Button size="sm" className="bg-[#004030] hover:bg-[#013d2b] text-white rounded-full text-xs h-8">Enquire</Button></Link>
                  </div>
                </div>
              ))}
            </div>
            {shown.length === 0 && <p className="text-center text-slate-400 py-10">No courses in this category.</p>}
          </>
        )}
      </div>
    </div>
  );
}
